import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { LoginContextProvider } from "./partials/context/LoginContext";
import { ContentContextProvider } from "./partials/context/ContentContext";
import { DomainContextProvider } from "./partials/context/DomainNameContext";
import { ChoosenDataSet, ChoosenDataSetProvider } from "./partials/context/ChoosenDataSet";
import { NewaddDomainProvider } from "./partials/context/NewAddDomain";
import { CityContextProvider } from "./partials/context/CityContext";
import { AlertContextProvider } from "./partials/context/AlertContext";
import { SelectedDataSetProvider } from "./partials/context/SelectedDataset";
import { LayerContextProvider } from "./partials/context/LayerContext";
import { ScrollToContextProvider } from "./partials/context/ScrollToContext";
import { DateContextProvider } from "./partials/context/DateContext";
import { UrlContextProvider } from "./partials/context/UrlContext";
import { LoadingContextProvider } from "./partials/context/Loading";
import { PlayContextProvider } from "./partials/context/PlayContext";
import { LayerAddContextProvider } from "./partials/context/AddedLayer";
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  
    <HashRouter>
    <LoginContextProvider>
      <LoadingContextProvider>
        <PlayContextProvider>
          <LayerAddContextProvider>
      <ScrollToContextProvider>
        <UrlContextProvider>
        <DateContextProvider>
      <CityContextProvider>
        <LayerContextProvider>
          <SelectedDataSetProvider>
          <ChoosenDataSetProvider>
            <AlertContextProvider>
          <NewaddDomainProvider>
        <DomainContextProvider>
        <ContentContextProvider>
          <App />
          </ContentContextProvider>
            </DomainContextProvider>
              </NewaddDomainProvider>
              </AlertContextProvider>
            </ChoosenDataSetProvider>
          </SelectedDataSetProvider>
          </LayerContextProvider>
          </CityContextProvider>
          </DateContextProvider>
          </UrlContextProvider>
            </ScrollToContextProvider>
            </LayerAddContextProvider>
          </PlayContextProvider>
        </LoadingContextProvider>
      </LoginContextProvider>
    </HashRouter>
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
